export const AUTOMATED_TEST_EMAIL_IDENTIFIERS = ['mailinator', 'team508266.m8r.co'];

export function isAutomatedTestingEmail(emailAddress?: string): boolean {
  const normalized = (emailAddress || '').toLowerCase();
  return AUTOMATED_TEST_EMAIL_IDENTIFIERS.some((id) => normalized.includes(id));
}
